var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6 0.89502H2.4C1.08 0.89502 0.012 1.97502 0.012 3.29502L0 17.695C0 19.015 1.08 20.095 2.4 20.095H21.6C22.92 20.095 24 19.015 24 17.695V3.29502C24 1.97502 22.92 0.89502 21.6 0.89502ZM21.12 5.99502L12.636 11.299C12.252 11.539 11.748 11.539 11.364 11.299L2.88 5.99502C2.75967 5.92747 2.6543 5.83621 2.57027 5.72676C2.48623 5.61732 2.42527 5.49195 2.39109 5.35826C2.35691 5.22458 2.3502 5.08534 2.37139 4.94899C2.39257 4.81263 2.4412 4.682 2.51434 4.56498C2.58747 4.44797 2.68359 4.34701 2.79687 4.26821C2.91015 4.18942 3.03825 4.13443 3.17339 4.10658C3.30854 4.07872 3.44794 4.07858 3.58315 4.10616C3.71835 4.13373 3.84656 4.18846 3.96 4.26702L12 9.29502L20.04 4.26702C20.1534 4.18846 20.2816 4.13373 20.4169 4.10616C20.5521 4.07858 20.6915 4.07872 20.8266 4.10658C20.9618 4.13443 21.0898 4.18942 21.2031 4.26821C21.3164 4.34701 21.4125 4.44797 21.4857 4.56498C21.5588 4.682 21.6074 4.81263 21.6286 4.94899C21.6498 5.08534 21.6431 5.22458 21.6089 5.35826C21.5747 5.49195 21.5138 5.61732 21.4297 5.72676C21.3457 5.83621 21.2403 5.92747 21.12 5.99502Z",
    fill: "#F6F6F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.69262241d3651b86fb482093b034cde5.svg";
export { ForwardRef as ReactComponent };